import { Fragment, useLayoutEffect, useState } from "react"
import Axios from "axios"

import Loading from "../loading/loading"

import fieldStyle from "./field.module.css"
import managerStyle from "manager/manager.module.css"
import EventFieldMaker from "manager/omega/form/EventFieldMaker"
import { uniqueCode } from "manager/omega/form/EventMaker"


export default function Field() {

    const branchInfo = window.EventManager.branchInfo
    const selectEevent = window.EventManager.selectEevent
    const fieldToggle = window.EventManager.fieldToggle
    const Set_fieldToggle = window.EventManager.Set_fieldToggle

    const branch_id = branchInfo['id']
    const event_id = selectEevent['id']

    const [fieldLoading, Set_fieldLoading] = useState(true)

    const [fieldList, Set_fieldList] = useState([])

    useLayoutEffect(() => {
        field_load()
    }, [fieldToggle, event_id])

    async function field_load() {
        await Set_fieldLoading(true)

        const result = await Axios
                        .post('/event/field', {
                            event_id: event_id,
                            use_branch: branch_id,
                        })
        const data = result['data']
        if(data !== '') {
            const new_field_list = []
            for(let i=0; i<data.length; i++) {
                new_field_list.push({
                    code: uniqueCode(),
                    ...data[i]
                })
            }
            await Set_fieldList(new_field_list)
            await Set_fieldLoading(false)
        }
    }

    async function field_save() {
        if(window.confirm('저장하시겠습니까?')) {
            const result = await Axios
                            .post('/event/field/save', {
                                event_id: event_id,
                                use_branch: branch_id,
                                field_list: fieldList
                            })
            const data = result['data']
            alert(data['message'])
        }
    }

    async function add() {
        Set_fieldList((preState) => {
            return(
                [
                    ...preState,
                    {
                        code: uniqueCode(),
                        type: "",
                        options: []
                    }
                ]
            )
        })
    }

    async function remove(code) {
        Set_fieldList((preState) => {
            return preState.filter((v) => {
                return v.code !== code
            })
        })
    }

    async function update(code, patch) {
        Set_fieldList((preState) => {
            return preState.map((v) => {
                return v.code === code ? {...v, ...patch} : v
            })
        })
    }

    return(
        <div
            id="field"
            className={fieldStyle['fieldWrap']}
            style={{
                display: fieldToggle ? 'flex' : 'none'
            }}
        >
            <Loading
                loading={fieldLoading}
            ></Loading>

            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "5px"
                }}
            >
                <div
                    style={{
                        display: "flex",
                    }}
                >
                    <button
                        type="button"
                        className={`
                            ${managerStyle['button']}
                            ${managerStyle['primary']}
                        `}
                        style={{
                            width: "max-content",
                            height: "30px",
                            paddingInline: "10px",
                            marginRight: "10px"
                        }}
                        onClick={() => field_save()}
                    >저장</button>

                    <button
                        type="button"
                        className={`
                            ${managerStyle['button']}
                            ${managerStyle['dark']}
                        `}
                        style={{
                            width: "max-content",
                            height: "30px",
                            paddingInline: "10px",
                            marginRight: "10px"
                        }}
                        onClick={() => add()}
                    >항목 추가</button>
                </div>

                <button
                    type="button"
                    className={`
                        ${managerStyle['button']}
                        ${managerStyle['secondary']}
                    `}
                    style={{
                        width: "70px",
                        height: "30px"
                    }}
                    onClick={() => Set_fieldToggle(false)}
                >닫기</button>
            </div>

            <div
                style={{
                    width: "100%",
                    height: "100%",
                    overflowY: "auto"
                }}
            >
                {fieldList
                .map((value, index) => {
                    return(
                        <Fragment key={value['code']}>
                            <EventFieldMaker
                                field={value}
                                onPatch={(code, patch) => update(code, patch)}
                                onRemove={(code) => remove(code)}
                            ></EventFieldMaker>
                        </Fragment>
                    )
                })}
            </div>
        </div>
    )
}